import { setLegalAgreement, setLegalModal, setUserEmail } from "../../../../store/signUp/slice";
import { selectFetchStatus, selectLegalAgreement } from "../../../../store/signUp/selectors";
import { useDispatch, useSelector } from "../../../../store/store";
import { checkSignUpThunk } from "../../../../store/signUp/thunks";
import { validateEmail } from "../../../../utils/generalHelpers";
import MotionWrapper from "../../../../containers/MotionWrapper";
import { setLegalTab } from "../../../../store/general/slice";
import { LegalTab } from "../../../../store/general/types";
import CheckBox from "../../../../components/CheckBox";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import { useNavigate } from "react-router-dom";
import { MouseEvent, useState } from "react";
import styles from './style.module.scss';

export default function RegisterEmail() {
    const fetchStatus = useSelector(selectFetchStatus);
    const [email, setEmail] = useState('');
    const agree = useSelector(selectLegalAgreement);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const openLegalModal = (e: MouseEvent<HTMLSpanElement>, tab: LegalTab) => {
        e.stopPropagation();
        dispatch(setLegalTab(tab));
        dispatch(setLegalModal(true));
    };

    const next = () => {
        if (!validateEmail(email)) {
            setError('Email address is invalid.');
            return;
        }

        dispatch(setUserEmail(email));
        dispatch(checkSignUpThunk(email));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.description}>
                Please sign up to continue to your account.
            </span>
            <Input
                type='email'
                label='Email'
                value={email}
                error={error}
                onChange={setEmail}
            />
            <div
                className={styles.agreement}
                onClick={() => dispatch(setLegalAgreement(!agree))}
            >
                <CheckBox checked={agree} onClick={() => dispatch(setLegalAgreement(!agree))} />
                <div className={styles.agreement_text}>
                    <span>By sign up, you agree to our</span>
                    <span
                        className={styles.agreement_text_link}
                        onClick={e => openLegalModal(e, 'Applicant_Terms')}
                    >
                        Terms of Use
                    </span>
                    and
                    <span
                        className={styles.agreement_text_link}
                        onClick={e => openLegalModal(e, 'Privacy_Policy')}
                    >
                        privacy policy
                    </span>
                </div>
            </div>
            <Button
                text="Next"
                onClick={next}
                disabled={!agree}
                className={styles.next}
                loading={fetchStatus === 'Pending'}
            />
            <div className={styles.backToSignIn}>
                Already have an account? <span onClick={() => navigate('/signin')}>
                    sign in
                </span>
            </div>
        </MotionWrapper>
    );
};
